'use client'

import s from './MainHeader.module.scss';
import {LogoIcon} from "@/app/[locale]/common/assets/LogoIcon/LogoIcon";
import {Link} from '@/i18n/routing';
import {DropDownMenu} from "@/app/[locale]/common/components/DropDownMenu/DropDownMenu";
import {ArrowIcon} from "@/app/[locale]/common/assets/ArrowIcon/ArrowIcon";
import {useEffect, useState} from "react";
import {TTrigger} from "@/app/[locale]/common/components/Header/types";
import {BurgerButton} from "@/app/[locale]/common/components/Header/BurgerMenu/BurgerButton";
import {BurgerMenu} from "@/app/[locale]/common/components/Header/BurgerMenu/BurgerMenu";
import {APP_ROUTES} from "../../../constants/app";
import {usePathname} from "next/navigation";
import {ModalWindow} from "@/app/[locale]/common/components/ModalWindow/ModalWindow";
import {ContactUsModalWindowContent} from "@/app/[locale]/common/components/ContactUsModalWindowContent/ContactUsModalWindowContent";
import {useTranslations} from "next-intl";
import {CustomButton} from "@/app/[locale]/common/components/CustomButton/CustomButton";

export const MainHeader = () => {
    const t = useTranslations('Header');
    const [previousPath, setPreviousPath] = useState<string | null>(null);
    const path = usePathname();
    const dropDownMenuStates = {
        'industries': false,
        'products': false,
        'solutions': false,
        'services': false,
    };
    const [ isOpenBurgerMenu, setIsOpenBurgerMenu ] = useState(false);
    const [ isOpen, setIsOpen ] = useState(dropDownMenuStates);
    const handleOpen = (type: TTrigger) => {
        setIsOpen({
            ...dropDownMenuStates,
            [type]: true,
        });
    };

    const handleClose = () => {
        setIsOpen({
            ...dropDownMenuStates
        });
    };

    const [ isOpenModalWindow, setIsOpenModalWindow ] = useState(false);
    const openModalWindow = () => setIsOpenModalWindow(true);
    const closeModalWindow = () => setIsOpenModalWindow(false);

    const handleOpenBurgerMenu = () => setIsOpenBurgerMenu(!isOpenBurgerMenu);

    useEffect(() => {
        if (path !== previousPath) {
            setPreviousPath(path);

            if (isOpenBurgerMenu) {
                handleOpenBurgerMenu();
            }
        }
    }, [path, previousPath]);

    return (
        <div className={s.mainHeader}>
            <div className={s.mainHeader_container}>
                <div className={s.mainHeader_burgerContainer}>
                    <BurgerButton isOpen={isOpenBurgerMenu} onClick={handleOpenBurgerMenu} />
                    <Link href={APP_ROUTES.MAIN} className={s.mainHeader_logoContainer}>
                        <LogoIcon />
                    </Link>
                </div>
                <Link href={APP_ROUTES.ABOUT_US} className={s.headerLink}>{ t('aboutUs.title') }</Link>
                <DropDownMenu
                    isOpen={isOpen.industries}
                    trigger={t('industries.title')}
                    list={t.raw('industries.list')}
                    href={APP_ROUTES.INDUSTRIES}
                    className={s.dropDown}
                    rightIcon={<ArrowIcon/>}
                    activeRIcon={<ArrowIcon active={true}/>}
                    leftMargin={'leftMarginSmall'}
                    handleOpen={() => handleOpen('industries')}
                    handleClose={handleClose}
                />
                {/*<DropDownMenu
                    isOpen={isOpen.products}
                    trigger={t('products.title')}
                    list={t.raw('products.list')}
                    href={APP_ROUTES.PRODUCTS}
                    className={s.dropDown}
                    rightIcon={<ArrowIcon/>}
                    activeRIcon={<ArrowIcon active={true}/>}
                    leftMargin={'leftMarginSmall'}
                    handleOpen={() => handleOpen('products')}
                    handleClose={handleClose}
                />*/}
                <DropDownMenu
                    isOpen={isOpen.solutions}
                    trigger={t('solutions.title')}
                    list={t.raw('solutions.list')}
                    href={APP_ROUTES.SOLUTIONS}
                    className={s.dropDown}
                    rightIcon={<ArrowIcon/>}
                    activeRIcon={<ArrowIcon active={true}/>}
                    leftMargin={'leftMarginSmall'}
                    handleOpen={() => handleOpen('solutions')}
                    handleClose={handleClose}
                />
                <DropDownMenu
                    isOpen={isOpen.services}
                    trigger={t('services.title')}
                    list={t.raw('services.list')}
                    href={APP_ROUTES.SERVICES}
                    className={s.dropDown}
                    rightIcon={<ArrowIcon/>}
                    activeRIcon={<ArrowIcon active={true}/>}
                    leftMargin={'leftMarginSmall'}
                    handleOpen={() => handleOpen('services')}
                    handleClose={handleClose}
                />
                <Link href={APP_ROUTES.PLATFORM} className={s.headerLink}>{ 'Platform' }</Link>
                <Link href={`${APP_ROUTES.PROJECTS}`} className={s.headerLink}>{t('projects.title')}</Link>
                <Link href={APP_ROUTES.NEWS} className={s.headerLink}>{ t('news.title') }</Link>
                <Link href={APP_ROUTES.CONTACTS} className={s.headerLink}>{ t('contacts.title') }</Link>
                <CustomButton size={'medium'} type={'compact1050Width'} onClick={openModalWindow}>{ t('button.title') }</CustomButton>
            </div>
            {
                isOpenBurgerMenu &&
                <BurgerMenu />
            }
            <ModalWindow isOpen={isOpenModalWindow} closeModalWindow={closeModalWindow}>
                <ContactUsModalWindowContent />
            </ModalWindow>
        </div>
    );
};